import { createSelector } from 'reselect'
import entities from 'entities'

const selectDevice = state => state.devices

const selectAllDevices = createSelector(
  selectDevice,
  devices =>
    devices.devices.map(device => {
      return {
        ...device,
        name_pretty: `${device.manufacturer} ${
          device.vanity_name
            ? entities.decodeHTML(device.vanity_name) + ' (' + device.name + ')'
            : device.name
        }`
      }
    })
)

const selectDevices = createSelector(
  selectAllDevices,
  devices =>
    devices.filter(device => {
      const name = device.name.toLowerCase()
      return !name.includes('general') && !name.includes('account')
    })
)

const selectDevicesFetching = createSelector(
  selectDevice,
  devices => devices.isFetching
)

const selectDeviceManufacturers = createSelector(
  selectDevice,
  devices => {
    const manufacturers = devices.devices.map(device => device.manufacturer)
    return [...new Set(manufacturers)]
  }
)

const selectDeviceSoftware = createSelector(
  selectDevice,
  devices => {
    const operatingSystems = devices.devices.map(device => device.os)
    return [...new Set(operatingSystems)]
  }
)

export {
  selectDevices,
  selectDevicesFetching,
  selectDeviceManufacturers,
  selectDeviceSoftware,
  selectAllDevices
}



// WEBPACK FOOTER //
// ./src/containers/DeviceSelector/selectors.js